export default "__VITE_ASSET__840d923f__"